/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

// Dev cockpit integration — guarded by the build-time FF_DEV_COCKPIT flag so the
// whole branch (and the imported chunk) is tree-shaken out of production builds.
//
// We use Vite's static `import.meta.glob` instead of `require(...)`: `require` is
// NOT defined in the browser ESM runtime, so the previous implementation always
// threw `ReferenceError: require is not defined`, silently fell into the catch,
// and left `devSimulator` null — disabling every State Simulator feature in dev.
type DevSimulatorModule = typeof import('@features/dev-cockpit/services/state-simulator');

const devSimulatorModules = import.meta.glob<DevSimulatorModule>(
  '@features/dev-cockpit/services/state-simulator.ts',
  { eager: true },
);

let devSimulator: DevSimulatorModule | null = null;
let devSimulatorResolved = false;

/**
 * Resolves the dev simulator module lazily, honoring the FF_DEV_COCKPIT flag.
 *
 * @returns The simulator module, or null when the cockpit is disabled.
 */
export function getDevSimulator(): DevSimulatorModule | null {
  if (devSimulatorResolved) return devSimulator;
  if (import.meta.env.FF_DEV_COCKPIT === 'true') {
    const entry = Object.values(devSimulatorModules)[0];
    if (entry) devSimulator = entry;
  }
  devSimulatorResolved = true;
  return devSimulator;
}

/**
 * Test-only hook that injects a dev simulator module and marks resolution as done,
 * bypassing the FF_DEV_COCKPIT gate so tests can exercise simulator behavior when
 * DEBUG is not set at compile time.
 *
 * @param mod - The simulator module to inject, or null to clear it
 * @internal
 */
export function __setDevSimulatorForTest(mod: DevSimulatorModule | null): void {
  devSimulator = mod;
  devSimulatorResolved = true;
}
